import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.acceptableIdModal__title),
  primaryAction: () => i18n.t(i18nKeys.acceptableIdModal__primaryAction),
  bulletText1: () => i18n.t(i18nKeys.acceptableIdModal__bulletText1),
  bulletText2: () => i18n.t(i18nKeys.acceptableIdModal__bulletText2),
  bulletText3: () => i18n.t(i18nKeys.acceptableIdModal__bulletText3),
  bulletText4: () => i18n.t(i18nKeys.acceptableIdModal__bulletText4),
  bulletText5: () => i18n.t(i18nKeys.acceptableIdModal__bulletText5),
  bulletText6: () => i18n.t(i18nKeys.acceptableIdModal__bulletText6),
  bulletText7: () => i18n.t(i18nKeys.acceptableIdModal__bulletText7),
}
